
import makerjs from "makerjs";

function C23(model, zoom, Param, fixedParam) {
  //w,h,w1,w2
  console.log("Param==", Param[0].param);
  console.log("Param==", Param[1].param);
  console.log("Param==", Param);
  var plate = model.plate, markers = model.markers, myZoom = zoom * 1,
  W = Param[0].param,H = Param[1].param, R1 = Param[2].param,R2 = Param[3].param,   
    //  plate = model.plate, markers = model.markers,
    markShift = fixedParam.markShift * 1, markShiftTwo = fixedParam.markShiftTwo * 1,
    markShiftThree = fixedParam.markShiftThree * 1, markShiftFour = fixedParam.markShiftFour * 1, markHolesOneD = fixedParam.markHolesOneD * 1,

    r1 = R1 * 1 * myZoom,
    r2 = R2 * 1 * myZoom,
    hh = H * 1 * myZoom,
    w = W * 1 * myZoom,
    h=w,
    rd1=r1/Math.sqrt(2),
    rd2=r2/Math.sqrt(2),
    x0 = 0,  y0 = r1,
    x1 = 0, y1 = w,
    x2 = hh,  y2 =w, 
    x3 = hh,  y3 = hh+r2,
    x4 = hh+r2,  y4 = hh,
    x5 = w,  y5 = hh,
    x6 = w,  y6 = 0,
    x7 = r1,  y7 = 0,
    
     glassH = h, glassW = w;
 

     if (r1 !== 0) {
      var TxtR1 = "R1=" +R1;
    } if (r2 !== 0) {
      var TxtR2 = "R2=" +R2;
    } if (hh !== 0) {
    var TxtH ="H=" + H;
  } if (w !== 0) {
    var TxtW = "W=" + W;
  }



  var drawAbnormalShapeC23 = {
    paths: {
      "LeftLLine": new makerjs.paths.Line([x0, y0], [x1, y1]),
      "LeftUpLine": new makerjs.paths.Line([x1, y1], [x2, y2]),
      "LeftRLine": new makerjs.paths.Line([x2, y2], [x3, y3]),
      "RightArcLine": new makerjs.paths.Arc([x3, y3], [x4, y4], r2, false, false),
      "BottomUpLine": new makerjs.paths.Line([x4, y4], [x5, y5]),      
      "RightLine": new makerjs.paths.Line([x5, y5], [x6, y6]),         
      "BottomLine": new makerjs.paths.Line([x6, y6], [x7, y7]),      
      "LeftArcLine": new makerjs.paths.Arc([x7, y7], [x0, y0], r1, false, true),
    }
  };
  var drawAbnormalShapeC23MarkW = {
    paths: {
      "BottomLine": new makerjs.paths.Line([x0, y7-markShift], [x6, y6-markShift]),
      "LeftShortLine": new makerjs.paths.Line([x0, y7], [x0, y7-2*markShift]),
      "RightShortLine": new makerjs.paths.Line([x6, y6], [x6, y6-2*markShift]),
    }
  };
  var drawAbnormalShapeC23MarkR1 = {
    paths: {
      "BottomLine": new makerjs.paths.Line([0, 0], [r1-rd1, r1-rd1]),
    }
  };
  var drawAbnormalShapeC23MarkR2 = {
    paths: {
      "BottomLine": new makerjs.paths.Line([hh+r2-rd2, hh+r2-rd2], [hh+rd2, hh+rd2]),
    }
  };
  var drawAbnormalShapeC23MarkH = {
    paths: {
      "Line": new makerjs.paths.Line([x6+markShift, y6], [x5+markShift, y5]),
      "UpShortLine": new makerjs.paths.Line([x5, y5], [x5+3*markShift, y5]),
      "DnShortLine": new makerjs.paths.Line([x6, y6], [x6+3*markShift, y6]),
    }
  };
  makerjs.model.addCaption(drawAbnormalShapeC23MarkR1, TxtR1, [r1-rd1, r1-rd1], [r1-rd1+5*markShift, r1-rd1]);//长度文字  
  makerjs.model.addCaption(drawAbnormalShapeC23MarkR2, TxtR2, [hh+rd2, hh+rd2], [hh+rd2+5*markShift, hh+rd2]);//长度文字  
  makerjs.model.addCaption(drawAbnormalShapeC23MarkW, TxtW, [x0, y7-3*markShift], [x6, y6-3*markShift]);//宽度文字
  makerjs.model.addCaption(drawAbnormalShapeC23MarkH, TxtH, [x6+3*markShift, y6], [x5+3*markShift, y5]);//宽度文字

  plate = {
    models: {
      drawAbnormalShapeC23: drawAbnormalShapeC23,
    }
  };
  markers = {
    models: {
      drawAbnormalShapeC23: drawAbnormalShapeC23,
      drawAbnormalShapeC23MarkR1: drawAbnormalShapeC23MarkR1,
      drawAbnormalShapeC23MarkR2: drawAbnormalShapeC23MarkR2,
      drawAbnormalShapeC23MarkW: drawAbnormalShapeC23MarkW,
      drawAbnormalShapeC23MarkH: drawAbnormalShapeC23MarkH,
    }
  };

  /*****************************************************************************/
  //return { plate, markers, glassW, glassH }

  return { w, h, plate, markers }
};


export default C23;